class Accordion extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector(".accordion__label");
    this.content = this.querySelector(".accordion__content");
    this.inner = this.querySelector(".accordion__inner");

    if (this.button && this.content) {
      this.button.addEventListener("click", this.toggle.bind(this));
    }
  }

  toggle() {
    const isOpen = this.inner.getAttribute("data-open") === "true";

    if (isOpen) {
      this.close();
    } else {
      this.open();
    }
  }

  open() {
    this.inner.setAttribute("data-open", "true");
    this.button.setAttribute("aria-expanded", "true");
    this.content.setAttribute("aria-hidden", "false");
    this.content.style.display = "block";

    // Animate the content
    this.content.style.maxHeight = "0px";
    this.content.style.overflow = "hidden";
    this.content.style.transition = "max-height 0.3s ease";

    // Get the actual height
    const height = this.content.scrollHeight;

    // Use setTimeout to trigger the transition
    setTimeout(() => {
      this.content.style.maxHeight = height + "px";
    }, 10);

    // Remove max-height after transition
    setTimeout(() => {
      this.content.style.maxHeight = "none";
      this.content.style.overflow = "visible";
    }, 310);
  }

  close() {
    this.inner.setAttribute("data-open", "false");
    this.button.setAttribute("aria-expanded", "false");
    this.content.setAttribute("aria-hidden", "true");

    // Set current height before animation
    const height = this.content.scrollHeight;
    this.content.style.maxHeight = height + "px";
    this.content.style.overflow = "hidden";
    this.content.style.transition = "max-height 0.3s ease";

    // Trigger animation
    setTimeout(() => {
      this.content.style.maxHeight = "0px";
    }, 10);

    // Hide after transition
    setTimeout(() => {
      this.content.style.display = "none";
      this.content.style.overflow = "visible";
    }, 310);
  }
}

customElements.define("accordion-element", Accordion);
